var MenuMobile = function($){
    var $this = this;

    $this.init = function(){

        $("#menuMob, #hide").click($this.openMenu);
        $(window).resize($this.onResize);
    };
    $this.onResize = function(){
           $this.MenuH();
    };

    $this.openMenu = function(){
        $('body').toggleClass('openmenu');
        $this.MenuH();
    };

    $this.MenuH = function(){
        var WinH = $(document).height();
        $(".openmenu .moduletable_menu").css('height',WinH);
        $(".TabDesk .moduletable_menu").css('height','auto');
    };
};

















